import ServiceExec from '@/common/utils/ServiceExec';
import { common } from '@/common/service/ApiList';
const { shopCategories, shopTypes, shopLocation, productCategories, userList, storeAccounts } = common;
import store from '@/store';

export default {
  translate: async ({ commit }, payload) => {
    const response = await ServiceExec.get('/common/translate', payload);
    if (response.status !== 200) return false;
    if (typeof response.data === 'number') return response.data;

    let txt = response.data;
    txt = txt.replaceAll('&amp;', '&');
    txt = txt.replaceAll('&quot;', '"');
    txt = txt.replaceAll('＆lt;', '<');
    txt = txt.replaceAll('＆gt;', '>');
    txt = txt.replaceAll('＆nbsp;', ' ');
    txt = txt.replaceAll('&#039;', "'");
    txt = txt.replaceAll('&#39;', "'");
    txt = txt.replaceAll('&#035;', '#');
    return txt;
  },

  translateBubble: async ({ commit }, payload) => {
    const response = await ServiceExec.get('/common/translate/bubble', payload);
    if (response.status !== 200) return false;
    if (typeof response.data === 'number') return response.data;

    let txt = response.data;
    txt = txt.replaceAll('&amp;', '&');
    txt = txt.replaceAll('&quot;', '"');
    txt = txt.replaceAll('＆lt;', '<');
    txt = txt.replaceAll('＆gt;', '>');
    txt = txt.replaceAll('＆nbsp;', ' ');
    txt = txt.replaceAll('&#039;', "'");
    txt = txt.replaceAll('&#39;', "'");
    txt = txt.replaceAll('&#035;', '#');
    return txt;
  },
  FETCH_SHOP_CATEGORIES: async ({ commit }) => {
    const { status, data } = await ServiceExec.get(shopCategories);
    commit('setShopCategories', data ?? []);
  },
  FETCH_SHOP_TYPES: async ({ commit }) => {
    const { status, data } = await ServiceExec.get(shopTypes);
    commit('setShopTypes', data ?? []);
  },
  FETCH_SHOP_LOCATIONS: async ({ commit }) => {
    const { status, data } = await ServiceExec.get(shopLocation);
    commit('setShopLocations', data);
  },
  FETCH_PRODUCT_CATEGORIES: async ({ commit }) => {
    const response = store.getters['admin/loginData'];
    const list = response.store;
    const storeNos = list.map((item) => item.storeNo);

    const { status, data } = await ServiceExec.get(productCategories, { storeNos });
    commit('setProductCategories', data ?? []);
  },
  FETCH_USER_LIST: async ({ commit }, parameter) => {
    const { status, data } = await ServiceExec.get(userList, parameter);
    if (status !== 200) return false;
    const { list, pageInfo } = data;
    commit('setUserPageInfo', pageInfo);
    commit('setUserList', list);
  },
  FETCH_STORE_ACCOUNTS: async ({ commit }, storeNo) => {
    const { status, data } = await ServiceExec.get(storeAccounts(storeNo));
    commit('setStoreAccounts', data ?? []);
  }
};
